import React from 'react';
import PropTypes from 'prop-types';


const HeadingComponent = (props) => {
  return (
    <h2 className="heading-component-wrapper large-font">
      {props.plainText}
      &nbsp;
      <strong>
          {props.strongText}
      </strong>
    </h2>
  );
};

HeadingComponent.prototype = {
  plainText: PropTypes.string,
  strongText: PropTypes.string,
}

export default HeadingComponent;